import { CardContent } from "@components/ui/card";
import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";
import Popover from "@/components/ui/popover";
import Spinner from "@/components/ui/spinner";
import { cn } from "@/lib/cn";
import { useGetCurrentUserQuery, useGetFoldersQuery } from "@/shared/services";
import { useMoveFolderCtx } from "../ctx";
import { MoveFolderFolders } from "./move-folder-dialog-list";

export const MoveFolderBody = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { folder } = useMoveFolderCtx();
  const { isLoading: foldersLoading } = useGetFoldersQuery();
  const { isLoading: userLoading } = useGetCurrentUserQuery();
  const isLoading = foldersLoading || userLoading;

  return (
    <CardContent>
      <span className="tw-mb-1 tw-block tw-font-sans tw-text-sm tw-font-medium tw-text-blue">
        Folder
      </span>
      <div className="tw-relative">
        {isLoading && (
          <span className="tw-absolute tw-inset-0 tw-z-1 tw-size-full tw-bg-white/50"></span>
        )}
        <Popover open={isOpen} onOpenChange={setIsOpen}>
          <Popover.Trigger>
            <div
              className={cn(
                "tw-relative tw-flex tw-w-full tw-h-9 tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-solid tw-bg-white tw-px-3 tw-py-1 tw-font-sans tw-text-base tw-font-normal tw-leading-6 tw-text-blue",
                isOpen ? "tw-border-primary" : "tw-border-blue-100",
                !folder.name && "tw-text-blue-500",
              )}
            >
              <span className="tw-flex-1 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
                {folder.name || "Select folder"}
              </span>
              <div className="tw-flex tw-shrink-0 tw-items-center">
                {isLoading ? (
                  <Spinner />
                ) : (
                  <IconChevronDown
                    className={cn("tw-text-base tw-transition-transform", {
                      "tw-rotate-180": isOpen,
                    })}
                    style={{ color: "#88819F" }}
                  />
                )}
              </div>
            </div>
          </Popover.Trigger>
          <Popover.Content className="tw-z-[10000] tw-w-[464px] tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white">
            <MoveFolderFolders setIsOpen={setIsOpen} />
          </Popover.Content>
        </Popover>
      </div>
    </CardContent>
  );
};
